import { render } from "./roadmap-nav-icon.vue.js?vue&type=template&id=57f41287!=!../../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./roadmap-nav-icon.vue?vue&type=template&id=57f41287"
const script = {}

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__